import Blocks from "@/components/Blocks"

export default function Tab({ block }) {
  if (block.innerBlocks.length === 0) {
    return null
  }

  return <Blocks blocks={block.innerBlocks} />
}
